import React from "react";
import PropTypes from "prop-types";
import Style from "../../../../assets/scss/custom.module.scss";
import { customers } from "../../../../locales/en";
import {
  status_short,
  status_update,
  user_types
} from "../../../../utils/data/data";
import Topaction from "../../../topaction/Topaction";
import { SearchText } from "../../../../locales/en";
import SearchField from "../../../common/searchbox/SearchField";

export default function CustomerListHeader({
  getID,
  getName,
  handleRefreshData,
  handleUserTypeSort,
  userSortType,
  handleStatusSort,
  statusSort,
  handleSearchChange,
  tempSearchQuery,
  handleKeyDown,
  showTopHideFilter,
  grpStatus,
  handleGroupStatusChange,
  disabled,
  data
}) {
  return (
    <>
      <div className={Style.contentToparea}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className={Style.contentTopheadTitle}>
              <h2>{customers.mainTitle}</h2>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="top-actionbar">
              <Topaction
                getID={getID}
                getName={getName}
                handleRefreshData={handleRefreshData}
                data={data}
              />
            </div>
          </div>
        </div>
        <div className="d-flex align-self-center justify-content-end flex-column flex-sm-row main-filter-bar mb-3">
          <div className="d-flex align-self-sm-center mb-2">
            <label
              htmlFor="Status-sort"
              className={`${Style.selectStatusLabel} d-flex align-self-center`}
            >
              {customers.userType}
            </label>
            <select
              name="status_sort"
              className={Style.selectShowStatus}
              onChange={handleUserTypeSort}
              value={userSortType}
              disabled={disabled}
            >
              {user_types.map((status, i) => (
                <option key={status.id ?? i} value={status.value}>
                  {status.name}
                </option>
              ))}
            </select>
          </div>
          <div className="d-flex align-self-sm-center mb-2">
            <label
              htmlFor="Customer-Status"
              className={`${Style.selectStatusLabel} d-flex align-self-center`}
            >
              {customers.statusFilter}
            </label>
            <select
              name="customer_status"
              className={Style.selectShowStatus}
              onChange={handleStatusSort}
              value={statusSort}
              disabled={disabled}
            >
              {status_short.map((status, i) => (
                <option key={status.id ?? i} value={status.value}>
                  {status.name}
                </option>
              ))}
            </select>
          </div>
          <div className="ms-3">
            <SearchField
              tempSearchQuery={tempSearchQuery}
              handleSearchChange={handleSearchChange}
              handleKeyDown={handleKeyDown}
              SearchText={SearchText}
              loading={disabled}
            />
          </div>
        </div>
      </div>
      {showTopHideFilter && (
        <div className="d-flex align-self-center top-hide-filter">
          <ul
            className={`${Style.topActioniconBtn} d-flex flex-wrap justify-content-md-end align-items-center ms-0`}
          >
            <li>
              <select
                name="status_sort"
                className={Style.selectShowStatus}
                value={grpStatus}
                onChange={handleGroupStatusChange}
                disabled={disabled}
              >
                {status_update.map((status, i) => (
                  <option key={status.id ?? i} value={status.value}>
                    {status.name}
                  </option>
                ))}
              </select>
            </li>
          </ul>
        </div>
      )}
    </>
  );
}

CustomerListHeader.propTypes = {
  getID: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  getName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  handleRefreshData: PropTypes.func.isRequired,
  handleUserTypeSort: PropTypes.func.isRequired,
  userSortType: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  handleStatusSort: PropTypes.func.isRequired,
  statusSort: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  tempSearchQuery: PropTypes.string.isRequired,
  handleKeyDown: PropTypes.func,
  showTopHideFilter: PropTypes.bool,
  grpStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleGroupStatusChange: PropTypes.func,
  setGrpStatus: PropTypes.func,
  disabled: PropTypes.bool,
  data: PropTypes.array
};
